var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, InputType, Int, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { PointEntryNode } from "../resources/PointEntry.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListPointEntriesResponse = class ListPointEntriesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [PointEntryNode], { nullable: false }),
    __metadata("design:type", Array)
], ListPointEntriesResponse.prototype, "data", void 0);
ListPointEntriesResponse = __decorate([
    ObjectType("ListPointEntriesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListPointEntriesResponse);
export { ListPointEntriesResponse };
let CreatePointEntryInput = class CreatePointEntryInput {
    comment;
    points;
    personFromUuid;
    opportunityUuid;
    teamUuid;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreatePointEntryInput.prototype, "comment", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], CreatePointEntryInput.prototype, "points", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreatePointEntryInput.prototype, "personFromUuid", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreatePointEntryInput.prototype, "opportunityUuid", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], CreatePointEntryInput.prototype, "teamUuid", void 0);
CreatePointEntryInput = __decorate([
    InputType()
], CreatePointEntryInput);
export { CreatePointEntryInput };
let ListPointEntriesArgs = class ListPointEntriesArgs extends FilteredListQueryArgs("PointEntryResolver", ["createdAt", "updatedAt"]) {
};
ListPointEntriesArgs = __decorate([
    ArgsType()
], ListPointEntriesArgs);
export { ListPointEntriesArgs };
//# sourceMappingURL=GetPointEntryByUuidResponse.js.map